import React from 'react';
import PropTypes from 'prop-types';
import styles from './DiscountTag.module.css';

const DiscountTag = ({
  discountPercent,
  className = '',
  isBrandRefresh = false,
}) => {
  if (!discountPercent || discountPercent <= 0) {
    return null;
  }

  if (isBrandRefresh) {
    return (
      <div
        data-part="save-badge"
        className={`${styles.brandRefresh} ${className}`.trim()}
      >
        Save up to
        {' '}
        {discountPercent}
        %
      </div>
    );
  }

  return (
    <div
      className={`
        inline-flex items-center justify-center
        !font-medium text-sm px-2.5 py-0.5 rounded-full
        bg-[#f3c244] text-black
        font-montserratMedium
        ${className}
      `}
    >
      Save up to
      {' '}
      {discountPercent}
      %
    </div>
  );
};

DiscountTag.propTypes = {
  discountPercent: PropTypes.number.isRequired,
  className: PropTypes.string,
  isBrandRefresh: PropTypes.bool,
};

DiscountTag.defaultProps = {
  className: '',
  isBrandRefresh: false,
};

export default DiscountTag;
